import { PAGE_SIZE } from '@/libs/constants'
import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const CONFIGURATION_ENDPOINT = '/v1.0/configuration'

const apiClient = new HttpClient(environment.adminFAPIUrl)

export interface GetAllConfigParameters {
  scope: {
    level: string
    countryId?: string
    customerNumber?: string
  }
  pageNumber?: number
  pageSize?: number
}

const getAllConfigs = async (scope, pageNumber = 1, pageSize = PAGE_SIZE[10]) => {
  const { level, countryId, customerNumber } = scope
  return apiClient.get(`${CONFIGURATION_ENDPOINT}/list`, {
    params: {
      level,
      pageNumber,
      pageSize,
      countryId,
      customerNumber,
    },
  })
}

const getAllGroups = async () => {
  return apiClient.get(`${CONFIGURATION_ENDPOINT}/groups`)
}

const getConfigsByGroup = async (groupName, scope, pageNumber, pageSize) => {
  return apiClient.get(`${CONFIGURATION_ENDPOINT}/list/${groupName}`, {
    params: {
      ...scope,
      pageNumber,
      pageSize,
    },
  })
}

const getAllCustomerConfigsFor = async (configKey: string) => {
  return apiClient.get(`${CONFIGURATION_ENDPOINT}/key/${configKey}`)
}

const getCountryConfigKey = async (configKey, countryId, dataType) => {
  return apiClient.get(
    `${CONFIGURATION_ENDPOINT}/country-settings/${configKey}`,
    {
      params: {
        CountryId: countryId,
        DataType: dataType,
      },
    },
  )
}

const updateConfig = async ({ level, countryId, customerNumber, name, value }) => {
  const data = {
    level,
    name,
    value: value.toString(),
    countryId: countryId ?? undefined,
    qualifier: customerNumber ?? undefined,
  }

  return apiClient.put(CONFIGURATION_ENDPOINT, {
    body: data,
  })
}

const updateDescription = async (
  { configurationName, description }: { configurationName: string; description: string },
) => {
  return apiClient.put(`${CONFIGURATION_ENDPOINT}/description`, {
    body: { configurationName, description },
  })
}

const resetConfig = async ({ level, countryId, qualifier, name }) => {
  const parameters: {
    level: string
    name: string
    countryId?: string
    qualifier?: string
  } = { level, name }

  if (countryId) {
    parameters.countryId = countryId
  }
  if (qualifier) {
    parameters.qualifier = qualifier
  }

  return apiClient.put(`${CONFIGURATION_ENDPOINT}/reset`, {
    body: parameters,
  })
}

const getCustomersByCountry = async (countryId: string) => {
  return apiClient.get(`${CONFIGURATION_ENDPOINT}/customer/${countryId}`)
}

const getAllAvailableCountries = async () => {
  return apiClient.get(`${CONFIGURATION_ENDPOINT}/country`)
}

export const adminConfigurationService = {
  getAllConfigs,
  getAllGroups,
  getConfigsByGroup,
  getAllCustomerConfigsFor,
  getCountryConfigKey,
  updateConfig,
  updateDescription,
  resetConfig,
  getCustomersByCountry,
  getAllAvailableCountries,
}
